<app-steps [current]="stepAtual()" [total]="totalSteps()"></app-steps>
<div>
  <h2 class="title">Dados cadastrais</h2>
  <form [formGroup]="form">
    <app-card-conteudo
      class="top-32"
      titulo="Revise seus dados cadastrais"
      descricao="Você pode editar suas informações nos campos abaixo"
    >
      <!-- linha: 48px entre os campos; grupo: 16px entre campos que andam juntos (ex.: DDD e celular). -->
      <div class="linhas">
        <div class="linha">
          <div class="campo campo--largo">
            <vivest-input
              formControlName="nome"
              label="Nome do cliente"
              placeholder=""
              name="nome"
              type="text"
              style="--vivest-input-inline-size: 100%"
            ></vivest-input>
          </div>
          <div class="campo">
            <vivest-input
              formControlName="cpf"
              label="CPF"
              placeholder=""
              name="cpf"
              type="text"
              style="--vivest-input-inline-size: 100%"
            ></vivest-input>
          </div>
        </div>

        <div class="linha">
          <div class="campo grupo">
            <div class="campo-curto">
              <vivest-input
                formControlName="ddd"
                [vivestFormat]="resideExterior() ? 'digits' : 'ddd'"
                [vivestMaxLength]="resideExterior() ? 4 : 2"
                label="DDD"
                placeholder=""
                name="ddd"
                type="tel"
                [status]="status('ddd')"
                [errorMessage]="mensagemErro('ddd')"
                style="--vivest-input-inline-size: 100%"
              ></vivest-input>
            </div>
            <div class="campo">
              <vivest-input
                formControlName="celular"
                vivestFormat="celular"
                label="Celular 1"
                placeholder=""
                name="celular"
                type="tel"
                [status]="status('celular')"
                [errorMessage]="mensagemErro('celular')"
                style="--vivest-input-inline-size: 100%"
              ></vivest-input>
            </div>
          </div>
          <div class="campo grupo">
            <div class="campo-curto">
              <vivest-input
                formControlName="ddd2"
                vivestFormat="ddd"
                label="DDD"
                placeholder=""
                name="ddd2"
                type="tel"
                style="--vivest-input-inline-size: 100%"
              ></vivest-input>
            </div>
            <div class="campo">
              <vivest-input
                formControlName="celular2"
                vivestFormat="celular"
                label="Celular 2 (Opcional)"
                placeholder=""
                name="celular2"
                type="tel"
                style="--vivest-input-inline-size: 100%"
              ></vivest-input>
            </div>
          </div>
          <div class="campo">
            <vivest-input
              formControlName="dataNascimento"
              label="Data de Nascimento"
              placeholder=""
              name="dataNascimento"
              type="text"
              style="--vivest-input-inline-size: 100%"
            ></vivest-input>
          </div>
        </div>

        <div class="linha">
          <div class="campo">
            <vivest-input
              formControlName="email"
              label="E-mail principal"
              placeholder=""
              name="email"
              type="email"
              [status]="status('email')"
              [errorMessage]="mensagemErro('email')"
              style="--vivest-input-inline-size: 100%"
            ></vivest-input>
          </div>
          <div class="campo">
            <vivest-input
              formControlName="emailSecundario"
              label="E-mail secundário (Opcional)"
              placeholder=""
              name="emailSecundario"
              type="email"
              [status]="status('emailSecundario')"
              [errorMessage]="mensagemErro('emailSecundario')"
              style="--vivest-input-inline-size: 100%"
            ></vivest-input>
          </div>
        </div>
      </div>

      <div class="pergunta-exterior">
        <div class="pergunta">
          <h4 class="mb-0">Você reside no exterior?</h4>
          <div class="opcoes">
            <vivest-radio
              label-variant="multi-line"
              name="reside-exterior"
              value="sim"
              [checked]="resideExterior()"
              (change)="resideExterior.set(true)"
            >
              Sim
            </vivest-radio>
            <vivest-radio
              label-variant="multi-line"
              name="reside-exterior"
              value="nao"
              [checked]="!resideExterior()"
              (change)="resideExterior.set(false)"
            >
              Não
            </vivest-radio>
          </div>
        </div>
      </div>

      @if (resideExterior()) {
        <div class="linhas">
          <div class="linha-menor">
            <div class="campo">
              <vivest-autocomplete
                formControlName="pais"
                [options]="paisOptions()"
                icon="search"
                label="País"
                placeholder=""
                name="pais"
                [status]="status('pais')"
                [errorMessage]="mensagemErro('pais')"
                style="--vivest-input-inline-size: 100%"
              ></vivest-autocomplete>
            </div>
            <div class="campo">
              <vivest-input
                formControlName="zipCode"
                vivestFormat="digits"
                label="ZIP Code"
                placeholder=""
                [vivestMaxLength]="15"
                name="zipCode"
                type="text"
                [status]="status('zipCode')"
                [errorMessage]="mensagemErro('zipCode')"
                style="--vivest-input-inline-size: 100%"
              ></vivest-input>
            </div>
            <div class="campo">
              <vivest-input
                formControlName="nif"
                vivestFormat="alfanumerico"
                label="NIF"
                placeholder=""
                [vivestMaxLength]="15"
                name="nif"
                type="text"
                [status]="status('nif')"
                [errorMessage]="mensagemErro('nif')"
                style="--vivest-input-inline-size: 100%"
              ></vivest-input>
            </div>
          </div>
        </div>
      } @else {
        <div class="linhas">
          <div class="linha">
            <div class="campo-cep">
              <vivest-input
                formControlName="cep"
                vivestFormat="cep"
                label="CEP"
                name="cep"
                type="text"
                icon="search"
                placeholder=""
                (blur)="searchCep()"
                [status]="status('cep')"
                [errorMessage]="mensagemErro('cep')"
                style="--vivest-input-inline-size: 100%"
              ></vivest-input>
            </div>
            <div class="campo campo--largo grupo">
              <div class="campo-curto">
                <vivest-input
                  formControlName="uf"
                  label="UF"
                  placeholder=""
                  [vivestMaxLength]="2"
                  name="uf"
                  type="text"
                  [status]="status('uf')"
                  [errorMessage]="mensagemErro('uf')"
                  style="--vivest-input-inline-size: 100%"
                ></vivest-input>
              </div>
              <div class="campo">
                <vivest-input
                  formControlName="cidade"
                  label="Cidade"
                  [vivestMaxLength]="50"
                  name="cidade"
                  type="text"
                  placeholder=""
                  [status]="status('cidade')"
                  [errorMessage]="mensagemErro('cidade')"
                  style="--vivest-input-inline-size: 100%"
                ></vivest-input>
              </div>
              <div class="campo">
                <vivest-input
                  formControlName="bairro"
                  label="Bairro"
                  placeholder=""
                  [vivestMaxLength]="60"
                  name="bairro"
                  type="text"
                  [status]="status('bairro')"
                  [errorMessage]="mensagemErro('bairro')"
                  style="--vivest-input-inline-size: 100%"
                ></vivest-input>
              </div>
            </div>
          </div>

          <div class="linha">
            <div class="campo campo--largo">
              <vivest-input
                formControlName="logradouro"
                label="Endereço"
                placeholder=""
                name="logradouro"
                type="text"
                [status]="status('logradouro')"
                [errorMessage]="mensagemErro('logradouro')"
                style="--vivest-input-inline-size: 100%"
              ></vivest-input>
            </div>
            <div class="campo grupo">
              <div class="campo-curto campo-curto--numero">
                <vivest-input
                  formControlName="numero"
                  vivestFormat="digits"
                  label="Número"
                  placeholder=""
                  [vivestMaxLength]="10"
                  name="numero"
                  type="text"
                  [status]="status('numero')"
                  [errorMessage]="mensagemErro('numero')"
                  style="--vivest-input-inline-size: 100%"
                ></vivest-input>
              </div>
              <div class="campo">
                <vivest-input
                  formControlName="complemento"
                  placeholder=""
                  label="Complemento (Opcional)"
                  [vivestMaxLength]="100"
                  name="complemento"
                  type="text"
                  [status]="status('complemento')"
                  [errorMessage]="mensagemErro('complemento')"
                  style="--vivest-input-inline-size: 100%"
                ></vivest-input>
              </div>
            </div>
          </div>
        </div>
      }

      <p class="aviso-opcionais">
        Remover e-mail secundário, complemento ou segundo celular não atualiza o cadastro central.
      </p>
    </app-card-conteudo>

    <app-card-conteudo
      class="top-64"
      titulo="Insira seus dados bancários"
      descricao="Indique onde devemos depositar a sua aposentadoria"
    >
      @if (contaOptions().length) {
        <div cardAcao class="conta-cadastrada">
          <vivest-select
            formControlName="contaCadastrada"
            [options]="contaOptions()"
            label="Contas cadastradas"
            name="contaCadastrada"
            placeholder=""
            [status]="status('contaCadastrada')"
            [errorMessage]="mensagemErro('contaCadastrada')"
            style="--vivest-select-inline-size: 100%"
          ></vivest-select>
        </div>
      }
      <div class="row campos">
        <div class="col-12 col-md-4">
          <vivest-autocomplete
            formControlName="banco"
            label="Banco"
            placeholder=""
            [options]="bancoOptions()"
            icon="search"
            name="banco"
            [status]="status('banco')"
            [errorMessage]="mensagemErro('banco')"
            style="--vivest-input-inline-size: 100%"
          ></vivest-autocomplete>
        </div>
        <div class="col-12 col-md-4">
          <vivest-input
            formControlName="agencia"
            vivestFormat="agencia"
            label="Agência"
            placeholder=""
            [vivestMaxLength]="7"
            name="agencia"
            type="text"
            [status]="status('agencia')"
            [errorMessage]="mensagemErro('agencia')"
            style="--vivest-input-inline-size: 100%"
          ></vivest-input>
        </div>
        <div class="col-12 col-md-4">
          <vivest-input
            formControlName="conta"
            vivestFormat="conta"
            label="Conta"
            placeholder=""
            [vivestMaxLength]="17"
            name="conta"
            type="text"
            [status]="status('conta')"
            [errorMessage]="mensagemErro('conta')"
            style="--vivest-input-inline-size: 100%"
          ></vivest-input>
        </div>
      </div>
    </app-card-conteudo>

    <app-card-conteudo
      class="top-64"
      titulo="Possui Moléstia grave?"
      descricao="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis eget dignissim risus, sed lobortis ex."
    >
      <div class="opcoes mt-3">
        <vivest-radio
          label-variant="multi-line"
          name="molestia-grave"
          value="sim"
          [checked]="possuiMolestiaGrave() === true"
          (change)="possuiMolestiaGrave.set(true)"
        >
          Sim
        </vivest-radio>
        <vivest-radio
          label-variant="multi-line"
          name="molestia-grave"
          value="nao"
          [checked]="possuiMolestiaGrave() === false"
          (change)="possuiMolestiaGrave.set(false)"
        >
          Não
        </vivest-radio>
      </div>
    </app-card-conteudo>

    <div class="d-flex justify-content-center align-items-center buttons-requerimento">
      <vivest-button variant="outline" size="md" (click)="onReturn()"> Voltar </vivest-button>
      <vivest-button variant="primary" size="md" [disabled]="!podeContinuar()" (click)="onSubmit()">
        <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
        Continuar para Configurar benefício
      </vivest-button>
    </div>
  </form>
</div>
